interface VerdictBadgeProps {
  verdict: string;
  className?: string;
}

interface StyleRule {
  match: RegExp;
  className: string;
  icon: string;
}

const rules: StyleRule[] = [
  { match: /谣言|证伪|不实/, className: "bg-primary-500 text-white", icon: "ri-close-circle-line" },
  { match: /反转/, className: "bg-accent-500 text-foreground-950", icon: "ri-loop-left-line" },
  { match: /属实|确认/, className: "bg-secondary-500 text-white", icon: "ri-checkbox-circle-line" },
  { match: /存疑|待核验|进行中/, className: "bg-background-300 text-foreground-800", icon: "ri-question-line" },
  { match: /已回应|官方/, className: "bg-accent-100 text-accent-900 border border-accent-300", icon: "ri-megaphone-line" },
];

export default function VerdictBadge({ verdict, className = "" }: VerdictBadgeProps) {
  const rule =
    rules.find((item) => item.match.test(verdict)) ?? {
      className: "bg-background-200 text-foreground-700",
      icon: "ri-price-tag-3-line",
    };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md px-2.5 py-1 text-xs font-semibold leading-none whitespace-nowrap ${rule.className} ${className}`}
    >
      <span className="flex h-3.5 w-3.5 items-center justify-center">
        <i className={`${rule.icon} text-[13px]`} aria-hidden="true" />
      </span>
      {verdict}
    </span>
  );
}